import { render, staticRenderFns } from "./workSidebar.vue?vue&type=template&id=290c38bc"
import script from "./workSidebar.vue?vue&type=script&lang=js"
export * from "./workSidebar.vue?vue&type=script&lang=js"
import style0 from "@dss/assets/styles/sidebar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports